import type { ButtonHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';
import { Icon, type IconName } from './icon';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: 'sm' | 'lg';
  block?: boolean;
  icon?: IconName;
  iconRight?: IconName;
}

export function Button({
  variant = 'secondary',
  size,
  block,
  icon,
  iconRight,
  children,
  className,
  type = 'button',
  ...rest
}: ButtonProps) {
  const iconSize = size === 'sm' ? 18 : 20;
  return (
    <button
      type={type}
      className={cn(
        'wb-btn',
        `wb-btn--${variant}`,
        size && `wb-btn--${size}`,
        block && 'wb-btn--block',
        className
      )}
      {...rest}
    >
      {icon && <Icon name={icon} size={iconSize} />}
      {children}
      {iconRight && <Icon name={iconRight} size={iconSize} />}
    </button>
  );
}
